import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ApiResponse } from '../shared/types';
import type {
  FamilySaleCheckoutData,
  FamilySaleCheckoutPayload,
  FamilySaleCompleteData,
  FamilySaleQuoteData,
  FamilySaleQuotePayload,
} from '../shared/types/family-sale.types';

/** Family Plan sell flow (CWS-1580): server-priced quote, one PaymentIntent, completion. */
@Injectable({ providedIn: 'root' })
export class FamilySaleService {
  constructor(private api: ApiService) {}

  quote(payload: FamilySaleQuotePayload): Observable<ApiResponse<FamilySaleQuoteData>> {
    return this.api.post<FamilySaleQuoteData>('order/family-plan/sale/quote', payload);
  }

  checkout(payload: FamilySaleCheckoutPayload): Observable<ApiResponse<FamilySaleCheckoutData>> {
    return this.api.post<FamilySaleCheckoutData>('order/family-plan/sale/checkout', payload);
  }

  /** Call after the client confirmed the PaymentIntent (incl. 3DS); same request_id as checkout. */
  complete(requestId: string): Observable<ApiResponse<FamilySaleCompleteData>> {
    return this.api.post<FamilySaleCompleteData>('order/family-plan/sale/complete', {
      request_id: requestId,
    });
  }
}
